import { jsx } from "react/jsx-runtime";
import { createContext, useMemo, useContext } from "react";
import { usePhones } from "../hooks/usePhones.js";
import "@tanstack/react-query";
import "../helpers/common.js";
import "./axios-provider.js";
import "axios";
const PhonesListContext = createContext({
  queryKey: null,
  data: void 0,
  queryResult: {}
});
const PhonesListProvider = ({
  children,
  auth,
  clinicReferenceId,
  operatorBaseURL
}) => {
  const { data, queryKey, queryResult } = usePhones({ clinicReferenceId, auth, disabled: !operatorBaseURL });
  const value = useMemo(
    () => ({
      data,
      queryKey,
      queryResult
    }),
    [queryKey, data, queryResult]
  );
  return /* @__PURE__ */ jsx(PhonesListContext.Provider, { value, children });
};
const usePhonesListProvider = () => {
  const context = useContext(PhonesListContext);
  if (context === void 0) {
    throw new Error("usePhonesListProvider must be used within a PhonesListContext");
  }
  return context;
};
export {
  PhonesListProvider,
  usePhonesListProvider
};
